import React from 'react';
import './aboutmodal.css';

const AboutModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="about-modal-overlay" onClick={onClose}>
      <div className="about-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="about-modal-close" onClick={onClose} aria-label="Fermer la modale">×</button>
        <h2 className="about-modal-title">À propos de moi</h2>
        <p>
          Je suis Gaëtan Crabeels, développeur web passionné basé en Belgique. 
          Je crée des sites vitrines, boutiques en ligne et applications sur mesure pour aider mes clients à se démarquer sur le web.
        </p>
        <p>
          Ma mission est de transformer vos idées en solutions digitales performantes et esthétiques, tout en respectant vos objectifs et votre budget.
        </p>
        <ul className="about-modal-values">
  {[
    "Design moderne et responsive",
    "Optimisation SEO et performance",
    "Support technique et suivi client"
  ].map((item) => (
    <li key={item}>
      <span>{item}</span>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={3} stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
      </svg>
    </li>
  ))}
</ul>

      </div>
    </div>
  );
};

export default AboutModal;
